import { createStructuredSelector } from "reselect";
import {
    MENU_ROLE,
    MENU_ROLE_SUCCESS,
    MENU_ROLE_ERROR
} from "../actions";

export const NAME = 'menuRole';

export const MenuRole = (filters, stateFilter) => ({
    type: MENU_ROLE,
    payload: { filters: filters, filtersState: stateFilter }
});

export const MenuRoleSuccess = (data) => ({
    type: MENU_ROLE_SUCCESS,
    payload: data
});

export const MenuRoleError = (error) => ({
    type: MENU_ROLE_ERROR,
    payload: error
});

const menuRole = (state) => state[NAME];

export const MenuRoleSelector = createStructuredSelector({
    menuRole
})
